import axios from "../axiosPlugin.js";

export const getFilmFeeService = data => {
  return axios({
    url: "/api/report/pdfFilmFee",
    method: "get",
    data: {
      data,
    },
  });
};
